import React, {useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import ProfileSystemTreeTableComponent from "./ProfileSystemTreeTableComponent";
import ProfileSystemSpecificationLayout from "./ProfileSystemSpecificationLayout";
import ProfileSystemAccessoriesLayout from "./ProfileSystemAccessoriesLayout";
import ProfileSystemFillingLayout from "./ProfileSystemFillingLayout";


const ProfileSystemPageLayout = () => {

    const [selectedRowId, setSelectedRowId] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <>
            <div className="px-4 pt-4 mb-2 sm:px-6 lg:px-8">
                <div className="flex items-center">
                    <h3 className="text-2xl">
                        {/*{location.state.item.article + " - " + location.state.item.supplierName + " - " + location.state.item.productName}*/}
                    </h3>
                </div>
                <div className='grid grid-cols-12 mt-4 gap-x-5'>

                    <div className="col-span-12 sm:col-span-4">
                        <ProfileSystemTreeTableComponent
                            selectedRowId={selectedRowId}
                            setSelectedRowId={setSelectedRowId}/>
                    </div>

                    <div className="col-span-12 sm:col-span-8">
                        <ProfileSystemSpecificationLayout treeSelectId={selectedRowId}/>
                        <ProfileSystemFillingLayout treeSelectId={selectedRowId}/>
                        <ProfileSystemAccessoriesLayout treeSelectId={selectedRowId}/>
                    </div>

                </div>
            </div>
        </>
    )
}

export default ProfileSystemPageLayout;
